/**
 * ProgramSection — the one card shell used by every section on the project
 * page. Hairline border, no shadow, uppercase label heading, actions on the
 * right. Matches the hero and the metric cards so the page reads as one
 * surface instead of a stack of differently-styled widgets.
 *
 * Use `tone="alert"` for genuine blockers — that swaps the label to amber and
 * adds a status dot, rather than tinting the whole card.
 */
export function ProgramSection({
  title,
  action,
  tone = "default",
  className = "",
  bodyClassName = "",
  children,
  ...rest
}) {
  const isAlert = tone === "alert";

  return (
    <section
      className={`rounded-2xl border border-border px-5 py-5 sm:px-6 ${className}`}
      {...rest}
    >
      <div className="flex items-center justify-between gap-3">
        <h2 className={`label-text flex items-center gap-2 ${isAlert ? "text-[#B96A43]" : ""}`}>
          {isAlert && <span className="w-1.5 h-1.5 rounded-full bg-[#B96A43]" />}
          {title}
        </h2>
        {action}
      </div>
      <div className={bodyClassName || "mt-4"}>{children}</div>
    </section>
  );
}

/** Shared class for a section's quiet header action. */
export const sectionActionClass =
  "h-8 rounded-full px-3 text-[13px] font-medium text-muted-foreground hover:bg-secondary hover:text-foreground";

export default ProgramSection;
